import React, { Component } from "react";
import { Table, Modal } from "react-bootstrap";
var dateFormat = require("dateformat");
class ItemCategoryViewModel extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const data =
      this.props.ItemCategoryDtls && this.props.ItemCategoryDtls.item
        ? this.props.ItemCategoryDtls && this.props.ItemCategoryDtls.item
        : null;
    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Item Category Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="feedbkModalTbl">
                  <Table responsive bordered  className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td>Name</td>
                        <td className="feedbkModalCap">
                          {" "}
                          {data !== null && data.name}
                        </td>
                      </tr>
                      <tr>
                        <td>Description</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.disc}
                        </td>
                      </tr>
                      <tr>
                        <td>Created Date</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            dateFormat(data.createdAt, "mediumDate")}
                        </td>
                      </tr>
                      <tr>
                        <td>Active</td>
                        <td className="feedbkModalCap">
                          {data !== null && data.isActive ? "Yes" : "No"}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}
export default ItemCategoryViewModel;
